import type { RouteObject } from 'react-router-dom';
import NotFound from '@/pages/NotFound';
import Home from '@/pages/home/page';
import ReportsPage from '@/pages/reports/page';
import ReportDetailPage from '@/pages/reports/detail/page';
import SubmitPage from '@/pages/submit/page';
import AboutPage from '@/pages/about/page';

const routes: RouteObject[] = [
  {
    path: '/',
    element: <Home />,
  },
  {
    path: '/reports',
    element: <ReportsPage />,
  },
  {
    path: '/reports/:id',
    element: <ReportDetailPage />,
  },
  {
    path: '/submit',
    element: <SubmitPage />,
  },
  {
    path: '/about',
    element: <AboutPage />,
  },
  {
    path: '*',
    element: <NotFound />,
  },
];

export default routes;